import { AD_ENTITY_TYPES, PLATFORMS, RISK_LEVELS } from '@silverfort-nodelibs/common/utils/consts';
import { RISK_INDICATORS } from '@silverfort-nodelibs/common/utils/insight';

const RISK_LEVELS_OPTIONS = Object.values(RISK_LEVELS).map((risk) => ({ value: risk.value, title: risk.label }));

const RISK_INDICATORS_OPTIONS = Object.keys(RISK_INDICATORS).map((indicatorKey) => ({
    value: indicatorKey,
    title: RISK_INDICATORS[indicatorKey].insightsTitle || RISK_INDICATORS[indicatorKey].authTitle || indicatorKey
}));

const ENTITY_TYPES_OPTIONS = [
    { title: 'User', value: AD_ENTITY_TYPES.USER },
    { title: 'Resource', value: AD_ENTITY_TYPES.SERVER }
];

const PLATFORM_OPTIONS = Object.values(PLATFORMS).map((platformValue) => ({
    value: platformValue,
    title: platformValue
}));

export { RISK_LEVELS_OPTIONS, RISK_INDICATORS_OPTIONS, ENTITY_TYPES_OPTIONS, PLATFORM_OPTIONS };
